module.exports = __webpack_public_path__ + "static/media/scale.d668f034.svg";